<template>
  <HeaderHome :user="this.$store.state.user.prenom"/>
  <div class="exam-container">
    <!-- ===== PAGE HEADER ===== -->
    <div class="page-header">
      <div class="page-header-left">
        <h1>Examen de Code</h1>
        <p>Suivi des élèves — scores, examens et archivage</p>
      </div>
      <div class="page-header-right">
        <button
          class="btn btn-secondary"
          v-if="!showArchive"
          @click="showArchives"
        >
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Archives
        </button>
        <button
          class="btn btn-danger"
          v-if="showArchive"
          @click="showArchives"
        >
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Quitter archives
        </button>
      </div>
    </div>

    <!-- ===== TOOLBAR : RECHERCHE + FILTRES ===== -->
    <div class="toolbar">
      <div class="search-wrap">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
          <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <SimpleTypeahead
          id="typeahead_id"
          class="search-input"
          placeholder="Rechercher un élève…"
          :items="leleves"
          :minInputLength="1"
          :itemProjection="(item) => item.fullname"
          @selectItem="selectItem"
          @onInput="searchEleve"
        />
        <button class="search-clear-btn" v-if="showBtn" @click="cancelChoice" title="Effacer">
          <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      
      <select class="form-select" name="statut" v-model="mode" @change="changeMode()">
        <option value="">Tous les statuts</option>
        <option value="Incomplet">Incomplet</option>
        <option value="Validées">Validées</option>
        <option value="A traiter">À traiter</option>
        <option value="Saisi">Saisi</option>
        <option value="Enregistrer">Enregistrer</option>
      </select>

      <select class="form-select" name="tests" v-model="mode" @change="changeMode()">
        <option value="">5 derniers tests</option>
        <option value="t20">-20</option>
        <option value="t24">20-24</option>
        <option value="t29">25-29</option>
        <option value="t34">30-34</option>
        <option value="t40">35-40</option>
      </select>
    </div>

    <!-- ===== TABLEAU ===== -->
    <div class="table-wrap">
      <DataTable
        :value="students"
        sortMode="multiple"
        :rows="10"
        v-model:filters="filters"
        v-model:selection="selectedItem"
        selectionMode="single"
        filterDisplay="menu"
        responsiveLayout="scroll"
        dataKey="id"
        @click="onSelected"
        :globalFilterFields="['nom', 'prenom', 'score', 'examen', 'resultat', 'solde', 'datep']"
        class="exam-datatable"
      >
        <Column field="datep" header="Date">
          <template #body="slotProps">
            <span class="cell-muted">{{ slotProps.data.datep }}</span>
          </template>
        </Column>

        <Column field="nom" header="Nom">
          <template #body="slotProps">
            <strong class="cell-name">{{ slotProps.data.nom }}</strong>
          </template>
        </Column>

        <Column field="prenom" header="Prénom">
          <template #body="slotProps">
            <span>{{ slotProps.data.prenom }}</span>
          </template>
        </Column>

        <Column field="prepaDate" header="Prépacode">
          <template #body="slotProps">
            <span v-if="slotProps.data.prepaDate" class="badge badge-blue">{{ slotProps.data.prepaDate }}</span>
            <span v-else class="badge badge-gray">—</span>
          </template>
        </Column>

        <Column field="statutDossier" header="Dossier">
          <template #body="slotProps">
            <span
              v-if="slotProps.data.statutDossier"
              :class="['dossier-badge', slotProps.data.statutDossier === 'Enregistrer' ? 'dossier-ok' : 'dossier-pending']"
            >{{ slotProps.data.statutDossier }}</span>
            <span v-else class="badge badge-gray">—</span>
          </template>
        </Column>

        <Column field="score" header="Score 5t">
          <template #body="slotProps">
            <template v-if="slotProps.data.score == null">
              <select
                class="score-select"
                name="score"
                id="score"
                v-model="scoreprepa"
                @change="changeScore(slotProps.data)"
              >
                <option value="null" disabled>Score ?</option>
                <option v-for="(s, index) in score" :value="s.value" :key="index">
                  {{ s.value }} / 40
                </option>
              </select>
            </template>
            <template v-else>
              <span
                class="score-pill action"
                :class="slotProps.data.score >= 35 ? 'score-success' : slotProps.data.score >= 30 ? 'score-warn' : 'score-danger'"
                @click="deleteScore(slotProps.data)"
                title="Cliquer pour supprimer"
              >
                {{ slotProps.data.score }} / 40
              </span>
            </template>
          </template>
        </Column>

        <Column field="examen" header="Examen">
          <template #body="slotProps">
            <template v-if="slotProps.data.examen == null">
              <Calendar
                class="exam-date-input"
                inputId="examen"
                v-model="dateExamen"
                showTime
                hourFormat="24"
                dateFormat="dd/mm/yy"
                :touchUI="isMobile"
                placeholder="jj/mm/aaaa --:--"
                @hide="changedateExam(slotProps.data)"
              />
            </template>
            <template v-else>
              <span class="exam-date-pill action" @click="deletedateExam(slotProps.data)" title="Cliquer pour supprimer">
                <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/><path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                {{ slotProps.data.examen }}
              </span>
            </template>
          </template>
        </Column>

        <Column field="resultat" header="Résultat">
          <template #body="slotProps">
            <template v-if="slotProps.data.resultat == null">
              <select
                class="score-select"
                name="score"
                id="score"
                v-model="resultatExam"
                @change="changeResultat(slotProps.data)"
              >
                <option value="null" disabled>Score ?</option>
                <option v-for="(s, index) in score" :value="s.value" :key="index">
                  {{ s.value }} / 40
                </option>
              </select>
            </template>
            <template v-else>
              <span
                class="score-pill action"
                :class="slotProps.data.resultat >= 35 ? 'score-success' : 'score-danger'"
                @click="deleteResultat(slotProps.data)"
                title="Cliquer pour supprimer"
              >
                {{ slotProps.data.resultat }} / 40
              </span>
            </template>
          </template>
        </Column>

        <Column field="solde" header="Solde">
          <template #body="slotProps">
            <span
              class="solde-val"
              :class="slotProps.data.solde > 0 ? 'solde-pos' : slotProps.data.solde < 0 ? 'solde-neg' : 'solde-zero'"
            >
              {{ slotProps.data.solde }} €
            </span>
          </template>
        </Column>

        <Column header="">
          <template #body="slotProps">
            <button
              @click="archiver(slotProps.data)"
              class="archive-btn"
              title="Archiver"
              v-if="slotProps.data.archive == false"
            >
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
            <button
              @click="desarchiver(slotProps.data)"
              class="archive-btn archive-btn--restore"
              title="Désarchiver"
              v-if="slotProps.data.archive == true && slotProps.data.resultat == null"
            >
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M3 12a9 9 0 1018 0 9 9 0 00-18 0M12 8v4l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </button>
          </template>
        </Column>
      </DataTable>

      <Paginator v-model:first="currentPage" :rows="10" :totalRecords="studentsCount" @page="onPaginate" class="exam-paginator" />
    </div>

  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import SimpleTypeahead from "vue3-simple-typeahead";
import HeaderHome from "../../components/home/HeaderHome.vue";


export default {
  name: "ExamCode",
  components: {
    SimpleTypeahead,
    HeaderHome
  },
  data() {
    return {
      students: [],
      studentsCount: 0,
      studentsArchive: [],
      studentsUnArchive: [],
      score: null,
      scoreprepa: null,
      resultatExam: null,
      dateExamen: null,
      showArchive: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      dossier: { statut: "" },
      mode: "",
      filtre: "",
      leleves: [],
      showBtn: false,
      currentPage: 0
    };
  },

  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },

  mounted() {
    this.getStudentsExamCode(0, "null");
  },

  methods: {
    cancelChoice() {
      this.showBtn = false;
      this.showArchive = false;
      this.getStudentsExamCode(0, "null");
      this.currentPage = 0;
    },

    selectItem(e) {
      this.showBtn = true;
      this.getStudentsExamCode(0, e.id);
    },

    searchEleve(e) {
      if ([3, 6, 9, 12, 15, 18, 21].includes(e.input.length)) {
        window.api
          .get("/code/name/eleves/search/" + e.input, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((response) => { this.leleves = response.data.utilisateurs; })
          .catch((error) => { console.log(error); });
      }
    },

    onPaginate(e) {
      let offset = e.first;
      if (this.mode == "null") {
        this.getStudentsExamCode(offset, this.mode);
      } else if (this.showArchive === true) {
        this.getStudentsExamCode(offset, "archive");
      } else {
        this.getStudentsExamCode(offset, this.mode);
      }
    },

    changeMode() {
      if (this.mode == "") {
        this.getStudentsExamCode(0, "null");
        this.currentPage = 0;
      } else {
        this.getStudentsExamCode(0, this.mode);
        this.currentPage = 0;
      }
    },

    showArchives() {
      if (!this.showArchive) {
        this.showArchive = true;
        this.getStudentsExamCode(0, "archive");
        this.currentPage = 0;
      } else {
        this.showArchive = false;
        this.getStudentsExamCode(0, "null");
        this.currentPage = 0;
      }
    },

    changeScore(student) {
      let thescore = this.scoreprepa;
      this.scoreprepa = null;
      window.api
        .patch("/prepacodes/" + student.prapaId, { scorePrepaCode: thescore }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
           this.showArchive ? this.getStudentsExamCode(this.currentPage, "archive") : this.getStudentsExamCode(this.currentPage, "null");
        })
        .catch((error) => { console.log(error); });
    },

    deleteScore(student) {
      window.api
        .patch("/prepacodes/" + student.prapaId, { scorePrepaCode: null }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          this.mode = "";
          this.currentPage = 0;
          this.showArchive ? this.getStudentsExamCode(0, "archive") : this.getStudentsExamCode(0, "null");
        })
        .catch((error) => { console.log(error); });
    },

    formatDateTimeLocal(date) {
      if (!date) return null;
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    changedateExam(student) {
      if (this.dateExamen === null) return;
      window.api
        .patch("/prepacodes/" + student.prapaId, { dateExamen: this.formatDateTimeLocal(this.dateExamen) }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          this.showArchive ? this.getStudentsExamCode(this.currentPage, "archive") : this.getStudentsExamCode(this.currentPage, "null");
          this.dateExamen = null;
          window.api.get("/confirm/code/date/eleve/" + student.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
            .then(() => {}).catch((error) => { console.log(error); });
        })
        .catch((error) => { console.log(error); });
    },

    deletedateExam(student) {
      window.api
        .patch("/prepacodes/" + student.prapaId, { dateExamen: null }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          this.mode = "";
          this.currentPage = 0;
          this.showArchive ? this.getStudentsExamCode(0, "archive") : this.getStudentsExamCode(0, "null");
        })
        .catch((error) => { console.log(error); });
    },

    changeResultat(student) {
      let archive = false;
      if (this.resultatExam >= 35) {
        archive = true;
      }
      window.api
        .patch("/prepacodes/" + student.prapaId, { resultExamen: this.resultatExam, archive }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          window.api.get("/confirm/code/eleve/" + student.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
            .then(() => {}).catch((error) => { console.log(error); });
          this.showArchive ? this.getStudentsExamCode(this.currentPage, "archive") : this.getStudentsExamCode(this.currentPage, "null");
          this.resultatExam = null;
        })
        .catch((error) => { console.log(error); });
    },

    deleteResultat(student) {
      window.api
        .patch("/prepacodes/" + student.prapaId, { resultExamen: null, archive: false }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          this.mode = "";
          this.currentPage = 0;
          this.showArchive ? this.getStudentsExamCode(0, "archive") : this.getStudentsExamCode(0, "null");
          this.resultatExam = null;
        })
        .catch((error) => { console.log(error); });
    },

    archiver(student) {
      window.api
        .patch("/prepacodes/" + student.prapaId, { archive: true }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => {
          this.mode = "";
          this.currentPage = 0;
          this.getStudentsExamCode(0, "null");
        })
        .catch((error) => { console.log(error); });
    },

    desarchiver(student) {
      window.api
        .patch("/prepacodes/" + student.prapaId, { archive: false }, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then(() => { 
          this.showArchive ? this.getStudentsExamCode(this.currentPage, "archive") : this.getStudentsExamCode(this.currentPage, "null"); 
        })
        .catch((error) => { console.log(error); });
    },

    getStudentsExamCode(offset, mode) {
      if (mode == "") mode = "null";

      if (this.$store.state.user.role.label == "secretaire") {
        window.api
          .get("/students/examen/" + this.$store.state.user.agence.id + "/" + offset + "/" + mode, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((response) => {
            this.studentsCount = response.data.count;
            this.studentsArchive = [];
            this.studentsUnArchive = [];
            this.students = [];
            response.data.students.forEach((e) => {
              if (e.archive || e.resultat >= 35) {
                this.studentsArchive.push(e);
              } else {
                this.studentsUnArchive.push(e);
              }
              this.students.push(e);
            });
            let scoreTab = [];
            for (let index = 0; index <= 40; index++) scoreTab.push({ value: index });
            this.score = scoreTab;
          })
          .catch((error) => { console.log(error); });
      } else {
        window.api
          .get("/students/examen/0", { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((response) => {
            this.showArchive = false;
            this.studentsUnArchive = response.data.student.filter((s) => s.archive == false);
            this.studentsArchive = response.data.student.filter((s) => s.archive == true);
            this.students = this.studentsUnArchive;
            let scoreTab = [];
            for (let index = 0; index <= 40; index++) scoreTab.push({ value: index });
            this.score = scoreTab;
          })
          .catch((error) => { console.log(error); });
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display&display=swap');

/* ===================== VARIABLES ===================== */
*, *::before, *::after { box-sizing: border-box; }

.exam-container {
  --green:       #1a9e6e;
  --green-light: #e8f7f1;
  --green-mid:   #c3ead9;
  --amber:       #f59e0b;
  --amber-light: #fef3c7;
  --blue:        #3b82f6;
  --blue-dark:   #2563eb;
  --blue-light:  #eff6ff;
  --purple:      #8b5cf6;
  --purple-light:#f5f3ff;
  --rose:        #f43f5e;
  --rose-light:  #fff1f2;
  --red:         #ef4444;
  --red-light:   #fee2e2;
  --text:        #1a1f2e;
  --text-2:      #64748b;
  --text-3:      #94a3b8;
  --bg:          #f4f6f9;
  --card:        #ffffff;
  --border:      #e2e8f0;
  --radius:      16px;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);

  color: var(--text);
  background: var(--bg);
  padding: 32px;
  min-height: 100vh;
  text-align: left;
}

/* ===================== PAGE HEADER ===================== */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
  flex-wrap: wrap;
  width: 70%;
  margin: auto;
}

.page-header h1 {
  font-size: 26px;
  font-weight: 400;
  color: var(--text);
  letter-spacing: -.4px;
  margin-bottom: 2px;
  font-weight: bold;
}

.page-header p {
  font-size: 13px;
  color: var(--text-2);
}

.page-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* ===================== BOUTONS ===================== */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
}

.btn-secondary {
  background: var(--bg);
  color: var(--text-2);
  border: 1px solid var(--border);
}
.btn-secondary:hover {
  background: #fff;
  color: var(--text);
  border-color: var(--text-3);
}

.btn-danger {
  background: var(--red-light);
  color: var(--red);
  border: 1px solid #fca5a5;
}
.btn-danger:hover {
  background: var(--red);
  color: #fff;
}

/* ===================== TOOLBAR ===================== */
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  width: 70%;
  margin: auto;
  margin-bottom: 2rem;
}

/* ===== BARRE DE RECHERCHE ===== */
.search-wrap {
  position: relative;
  flex: 1;
  min-width: 220px;
  display: flex;
  align-items: center;
}

.search-wrap > svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-3);
  pointer-events: none;
  z-index: 1;
}

/* Cible l'input généré par SimpleTypeahead */
.search-wrap :deep(input),
.search-input {
  width: 100%;
  padding: 10px 36px 10px 36px;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 13px;
  background: #fff;
  color: var(--text);
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.search-wrap :deep(input):focus,
.search-input:focus {
  border-color: var(--blue);
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}
.search-wrap :deep(input)::placeholder,
.search-input::placeholder { color: var(--text-3); }

/* Dropdown suggestions de SimpleTypeahead */
.search-wrap :deep(.simple-typeahead-list) {
  position: absolute;
  top: calc(100% + 4px);
  left: 0; right: 0;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,.1);
  z-index: 200;
  overflow: hidden;
  max-height: 220px;
  overflow-y: auto;
}
.search-wrap :deep(.simple-typeahead-list-item) {
  padding: 10px 14px;
  font-size: 13px;
  color: var(--text);
  cursor: pointer;
  border-bottom: 1px solid var(--border);
  transition: background .1s;
}
.search-wrap :deep(.simple-typeahead-list-item:last-child) { border-bottom: none; }
.search-wrap :deep(.simple-typeahead-list-item:hover),
.search-wrap :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background: var(--blue-light);
  color: var(--blue-dark);
}

.search-clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px; height: 22px;
  border-radius: 50%;
  background: var(--border);
  border: none;
  color: var(--text-2);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  transition: all .12s;
  z-index: 1;
}
.search-clear-btn:hover { background: var(--red-light); color: var(--red); }

/* ===== SELECT FILTRES ===== */
.form-select {
  padding: 9px 32px 9px 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: var(--text);
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
  white-space: nowrap;
}
.form-select:focus { border-color: var(--blue); }

/* ===================== TABLE WRAP ===================== */
.table-wrap {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  width: 70%;
  margin: auto;
}

/* Override PrimeVue DataTable pour adopter le style maison */
.exam-container :deep(.exam-datatable .p-datatable-thead > tr > th) {
  padding: 11px 14px;
  text-align: left;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--text-3);
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  border-right: none;
}

.exam-container :deep(.exam-datatable .p-datatable-tbody > tr) {
  border-bottom: 1px solid var(--border);
  transition: background .1s;
  cursor: pointer;
}
.exam-container :deep(.exam-datatable .p-datatable-tbody > tr:last-child) {
  border-bottom: none;
}
.exam-container :deep(.exam-datatable .p-datatable-tbody > tr:hover) {
  background: #f8fafc !important;
}
.exam-container :deep(.exam-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #eff6ff !important;
}

.exam-container :deep(.exam-datatable .p-datatable-tbody > tr > td) {
  padding: 13px 14px;
  font-size: 13px;
  color: var(--text);
  border-right: none;
  border-bottom: none;
}

/* ===== Cellules ===== */
.cell-muted {
  color: var(--text-2);
  font-size: 12px;
}

.cell-name {
  font-weight: 700;
  color: var(--text);
}

/* ===== Badges ===== */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.badge-gray  { background: #f1f5f9; color: var(--text-2); }
.badge-blue  { background: var(--blue-light); color: #1d4ed8; }
.badge-green { background: var(--green-light); color: #065f46; }

/* ===== Dossier ===== */
.dossier-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .01em;
}
.dossier-ok      { background: var(--green-light); color: #065f46; }
.dossier-pending { background: var(--blue-light);  color: #1d4ed8; }

/* ===== Score select ===== */
.score-select {
  padding: 5px 28px 5px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 12px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 8px center;
  -webkit-appearance: none;
  color: var(--text-2);
  cursor: pointer;
  outline: none;
  max-width: 130px;
  transition: border-color .15s;
}
.score-select:focus { border-color: var(--blue); }

/* ===== Score pill (valeur affichée) ===== */
.score-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}
.score-success { background: var(--green-light); color: #065f46; }
.score-warn    { background: var(--amber-light);  color: #b45309; }
.score-danger  { background: var(--red-light);    color: #b91c1c; }

/* ===== Date examen ===== */
.exam-date-input :deep(.p-inputtext) {
  padding: 5px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 12px;
  color: var(--text-2);
  outline: none;
  cursor: pointer;
  transition: border-color .15s;
  max-width: 180px;
}
.exam-date-input :deep(.p-inputtext:focus) { border-color: var(--blue); }

.exam-date-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: var(--blue-light);
  color: #1d4ed8;
  white-space: nowrap;
  transition: all .12s;
}
.exam-date-pill:hover { background: #dbeafe; }

/* ===== Solde ===== */
.solde-val  { font-weight: 700; font-size: 13px; }
.solde-pos  { color: var(--green); }
.solde-neg  { color: var(--red); }
.solde-zero { color: var(--text-3); }

/* ===== Bouton archiver ===== */
.archive-btn {
  width: 28px; height: 28px;
  border-radius: 8px;
  background: var(--red-light);
  color: var(--red);
  border: none;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .12s;
}
.archive-btn:hover { background: var(--red); color: #fff; }

.archive-btn--restore {
  background: var(--amber-light);
  color: #b45309;
}
.archive-btn--restore:hover { background: var(--amber); color: #fff; }

/* ===== Curseur action ===== */
.action { cursor: pointer; }

/* ===== Pagination PrimeVue ===== */
.exam-container :deep(.exam-paginator) {
  border-top: 1px solid var(--border);
  background: transparent;
  padding: 12px 14px;
  font-size: 13px;
}
.exam-container :deep(.exam-paginator .p-paginator-element) {
  border-radius: 8px;
  min-width: 30px;
  height: 30px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-2);
  border: none;
  background: none;
  transition: all .12s;
}
.exam-container :deep(.exam-paginator .p-paginator-element:hover) {
  background: var(--bg);
  color: var(--text);
}
.exam-container :deep(.exam-paginator .p-paginator-element.p-highlight) {
  background: var(--blue);
  color: #fff;
  font-weight: 700;
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 768px) {
  .exam-container { padding: 16px; }
  .toolbar { flex-direction: column; align-items: stretch; }
  .form-select { width: 100%; }
}
</style>